import Phaser from 'phaser';
import { NPC_REGISTRY } from '../data/npcRegistry';
import { SPRITE_REGISTRY } from '../data/spriteRegistry';

export class Spawner {
  static spawnNPC(scene: Phaser.Scene, x: number, y: number, key: string): Phaser.GameObjects.Sprite | null {
    const def = NPC_REGISTRY[key];
    if (!def) {
      console.warn(`NPC definition not found for key: ${key}`);
      return null;
    }

    // Check if the atlas exists
    if (!scene.textures.exists(def.atlas)) {
      console.warn(`Atlas '${def.atlas}' not loaded for NPC '${key}'`);
      return null;
    }

    const sprite = scene.add.sprite(x, y, def.atlas, def.defaultFrame);
    
    // Play default animation if available - use try/catch in case animation doesn't exist
    if (def.animations.length > 0) {
      try {
        // Check if the animation exists before playing
        if (scene.anims.exists(def.defaultFrame)) {
          sprite.play(def.defaultFrame);
        }
      } catch (e) {
        console.warn(`Failed to play animation '${def.defaultFrame}' for NPC '${key}':`, e);
      }
    }

    return sprite;
  }

  static spawnSprite(scene: Phaser.Scene, x: number, y: number, key: string): Phaser.GameObjects.Sprite | null {
    const def = SPRITE_REGISTRY[key];
    if (!def) {
        console.warn(`Sprite definition not found for key: ${key}`);
        return null;
    }

    // Check if the atlas exists
    if (!scene.textures.exists(def.atlas)) {
      console.warn(`Atlas '${def.atlas}' not loaded for sprite '${key}'`);
      return null;
    }
    
    const sprite = scene.add.sprite(x, y, def.atlas, def.frame);
    
    if (def.animation) {
        // If there's a custom animation config, we might need to create it on the fly or assume it's created.
        // For this demo, we assume pre-created or just static.
    }
    
    return sprite;
  }
}
